// Bibliotecas do framework
import React from "react";
import { Link, useHistory } from "react-router-dom";

// Estilização
import "../style-meteriais.css";

// Ícones
import { GiSonicBoom } from "react-icons/gi";

// Barra superior
import Header from "../../Header";

export default function HomeMateriais() {
    // Define a navegação
    const nav = useHistory();

    // Função para navegação entre conteúdos cadastrados
    function go(page: string) {
        nav.push(`/materiais/${page}`);
    }

    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">
                    <h3>Materiais Disponíveis</h3>

                    <div className="grid-row">
                        <div className="coluna-3 pad-r">
                            <div className="caixa-opcao" onClick={() => go("1")}>
                                <GiSonicBoom size={40} />
                                <p>Surgimento dos Elementos</p>
                            </div>
                        </div>

                    </div>
                    
                </div>
            </div>

        </div>
    );
}